import { PermissionsModel } from '../../../../../common/entity/permissions.model';
import { LovValueSummary } from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import { UserSummary } from '../../../../../account/modules/user/api/entity/userSummary.model';
import { Moment } from 'moment';
import { WorkflowTaskTriggerModel } from '../trigger/workflowTaskTrigger.model';
import { SummaryModel } from '../../../../../common/entity/summary.model';
import { WorkflowTaskDefinitionModel } from '../../../definition/api/model/workflowTaskDefinition.model';
import {MomentAdapter} from '../../../../../../shared/utils/moment.utils';
import {WorkflowTaskAttributeSummaryModel} from '../attribute/workflowTaskAttributeSummary.model';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {MessageModel} from '../../../../../message/api/model/messageModel';


export class WorkflowTaskSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    workflowTaskDefinition: WorkflowTaskDefinitionModel;
    publicAttributes: WorkflowTaskAttributeSummaryModel[] = [];
    status: LovValueSummary;
    statusDetails: string;
    assignedUser: UserSummary;
    deadline: Moment;
    trigger: WorkflowTaskTriggerModel;
    errorCode: string;
    executionStart: Moment;
    executionEnd: Moment;
    label: string;
    createdAt: Moment;
    logKey: string;
    human = false;
    partner: PartnerSummaryModel;
    initialMessageContent: string;

    isOverdue(): boolean {
        return this.deadline && this.deadline.isBefore(MomentAdapter.current().get()) && (
            this.status?.value === WorkflowTaskStatus.TASK_STATUS_ERROR ||
            this.status?.value === WorkflowTaskStatus.TASK_STATUS_NOT_STARTED ||
            this.status?.value === WorkflowTaskStatus.TASK_STATUS_IN_PROGRESS
        );
    }
}

export enum WorkflowTaskStatus {
    TASK_STATUS_NOT_STARTED = 'TASK_STATUS_NOT_STARTED',
    TASK_STATUS_IN_PROGRESS = 'TASK_STATUS_IN_PROGRESS',
    TASK_STATUS_DONE = 'TASK_STATUS_DONE',
    TASK_STATUS_ERROR = 'TASK_STATUS_ERROR',
    TASK_STATUS_CANCELLED = 'TASK_STATUS_CANCELLED'
}

export enum WorkflowTaskType {
    WORKFLOW_TASK_TYPE_APPLICATION = 'WORKFLOW_TASK_TYPE_APPLICATION',
    WORKFLOW_TASK_TYPE_HUMAN = 'WORKFLOW_TASK_TYPE_HUMAN',
}

export const WORKFLOW_TASK_BUSINESS_CONTEXT_NAME = 'WORKFLOW_TASK';
export enum WorkflowTaskPermission {
    WORKFLOW_TASK_PERMISSION_EXECUTE = 'WORKFLOW_TASK_PERMISSION_EXECUTE'
}
